import { holterConsultRequestSections } from '@common/validation/customControls/cardiology/holter/holterConsultRequestSchemas';
import { getPsDataInputComponents } from '@frontend/components/pages/customControls/utils/v1/labResults/getPsDataInputComponents';
import { EditForm } from '@frontend/formEngine/editForm/EditForm';
import { HolterConsultationFollowingSteps } from '../customComponents/HolterConsultationFollowingSteps';
import { getMedicationInputComponents } from '../utils/getMedicationInputComponents';
import { getRecipientDataInputComponents } from '../utils/getRecipientDataInputComponents';
import { getReferralDataInputComponents } from '../utils/getReferralDataInputComponents';

export function HolterConsultRequestEdit() {
    const inputComponents = new Map([
        ...getMedicationInputComponents(),
        ...getPsDataInputComponents(),
        ...getRecipientDataInputComponents(),
        ...getReferralDataInputComponents(),
    ]);

    return (
        <>
            <EditForm
                inputComponents={inputComponents}
                sections={holterConsultRequestSections}
            />

            <HolterConsultationFollowingSteps />
        </>
    );
}
